export const NAME_AFFILIATE_COOKIES = 'Affiliate-Code';
export const NAME_AFFILIATE_PARAM = 'ac';
